/* Animated scene as an extra FIRST gallery slide, with the customer's engraving drawn on its plaque.
   Config comes from snippets/scene-slide.liquid (window.__SCENE). No images are generated at runtime:
   one blank-plaque still, one small clip (candle / smoke / curtain / flag) or a CSS pendulum, and a canvas for the text. */
(function () {
  'use strict';
  var C = window.__SCENE;
  if (!C || window.__sceneInit) return;
  window.__sceneInit = true;

  var FONT = '"Playfair Display", Georgia, serif';
  var SAMPLE = C.g === 'F' ? 'Marguerite Aldous\n1947 - 2024\nBeloved Mother' : 'Harlan Ostrander\n1944 - 2023\nBeloved Father';
  var Q = C.quad;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 750px)');

  function dist(a, b) { return Math.hypot(a[0] - b[0], a[1] - b[1]); }
  var PW = (dist(Q[0], Q[1]) + dist(Q[3], Q[2])) / 2;
  var PH = (dist(Q[0], Q[3]) + dist(Q[1], Q[2])) / 2;
  var FW = 720;
  var FH = Math.round(FW * PH / PW);
  var CX = (Q[0][0] + Q[1][0] + Q[2][0] + Q[3][0]) / 4;
  var CY = (Q[0][1] + Q[1][1] + Q[2][1] + Q[3][1]) / 4;
  var ZOOM = Math.max(2, Math.min(4.5, 0.55 * 1080 / PW));

  function homography(src, dst) {
    var A = [], b = [], i, c, r, k;
    for (i = 0; i < 4; i++) {
      var x = src[i][0], y = src[i][1], u = dst[i][0], v = dst[i][1];
      A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]); b.push(u);
      A.push([0, 0, 0, x, y, 1, -v * x, -v * y]); b.push(v);
    }
    for (c = 0; c < 8; c++) {
      var p = c;
      for (r = c + 1; r < 8; r++) if (Math.abs(A[r][c]) > Math.abs(A[p][c])) p = r;
      var t = A[c]; A[c] = A[p]; A[p] = t; t = b[c]; b[c] = b[p]; b[p] = t;
      for (r = c + 1; r < 8; r++) {
        var f = A[r][c] / A[c][c];
        for (k = c; k < 8; k++) A[r][k] -= f * A[c][k];
        b[r] -= f * b[c];
      }
    }
    var h = new Array(8);
    for (r = 7; r >= 0; r--) {
      var s = b[r];
      for (k = r + 1; k < 8; k++) s -= A[r][k] * h[k];
      h[r] = s / A[r][r];
    }
    return h;
  }
  var H = homography([[0, 0], [FW, 0], [FW, FH], [0, FH]], Q);
  var MATRIX = 'matrix3d(' + [H[0], H[3], 0, H[6], H[1], H[4], 0, H[7], 0, 0, 1, 0, H[2], H[5], 0, 1].join(',') + ')';

  var css = document.createElement('style');
  css.textContent =
    '.sc-media{position:relative;width:min(100%,70dvh);aspect-ratio:1/1;margin:auto;overflow:hidden;background:#000;flex:none}' +
    '.sc-world{position:absolute;left:0;top:0;width:1080px;height:1080px;transform-origin:0 0;will-change:transform}' +
    '.sc-lit{position:absolute;left:0;top:0;width:1080px;height:1080px}' +
    '.sc-world.is-candle .sc-lit{filter:brightness(calc(1 + .12*var(--b,0)))}' +
    '.sc-world.sc-glide{transition:transform 1.9s cubic-bezier(.45,0,.2,1)}' +
    '.sc-still{position:absolute;left:0;top:0;width:1080px;height:1080px;display:block;max-width:none}' +
    '.sc-clip{position:absolute;object-fit:cover;opacity:0;transition:opacity .8s;pointer-events:none;max-width:none;' +
    '-webkit-mask-image:radial-gradient(ellipse at 50% 50%,#000 72%,transparent 100%);mask-image:radial-gradient(ellipse at 50% 50%,#000 72%,transparent 100%)}' +
    '.sc-clip.is-candle{-webkit-mask-image:radial-gradient(ellipse at 50% 50%,#000 55%,transparent 100%);mask-image:radial-gradient(ellipse at 50% 50%,#000 55%,transparent 100%)}' +
    '.sc-clip.is-edge{-webkit-mask-image:linear-gradient(to right,#000 86%,transparent 100%),linear-gradient(to bottom,#000 93%,transparent 100%);-webkit-mask-composite:source-in;' +
    'mask-image:linear-gradient(to right,#000 86%,transparent 100%),linear-gradient(to bottom,#000 93%,transparent 100%);mask-composite:intersect}' +
    '.sc-clip.is-on{opacity:1}' +
    '.sc-glow{position:absolute;left:-498.7px;top:-71.5px;width:1242px;height:1242px;border-radius:50%;pointer-events:none;mix-blend-mode:soft-light;opacity:.9;' +
    'transform:scale(calc(1 + .05*var(--b,0)));background:radial-gradient(circle,rgba(255,170,70,.9),rgba(255,140,40,.35) 51%,transparent 100%)}' +
    '.sc-pwin{position:absolute;overflow:hidden;pointer-events:none}' +
    '.sc-pend{position:absolute;left:0;top:0;width:100%;height:100%;max-width:none;background:none!important;transform-origin:54% -8.4%;animation:sc-sw 1.1s ease-in-out infinite alternate}' +
    '.sc-pend.sc-sh{animation-name:sc-sws;opacity:.95}' +
    '@keyframes sc-sw{from{transform:rotate(-9deg)}to{transform:rotate(9deg)}}' +
    '@keyframes sc-sws{from{transform:rotate(-10.5deg)}to{transform:rotate(10.5deg)}}' +
    '.sc-eng{position:absolute;left:0;top:0;transform-origin:0 0;mix-blend-mode:multiply;pointer-events:none;opacity:1;transition:opacity .25s}' +
    '.sc-eng.is-sample{opacity:.85}.sc-eng.is-off{opacity:0}' +
    '.sc-vig{position:absolute;inset:0;pointer-events:none;background:radial-gradient(ellipse at 45% 50%,transparent 38%,rgba(0,0,0,.6) 100%)}' +
    '.sc-media.sc-fill{position:absolute;left:0;top:0;right:0;bottom:0;width:auto;aspect-ratio:auto;margin:0;background:#000}' +
    '@media (max-width:749px){.urn-live__stage[data-sc-host] .urn-live__img,.urn-live__stage[data-sc-host] .urn-live__warp{visibility:hidden!important}}' +
    '@media (min-width:750px){.urn-live__stage[data-sc-host] .sc-media{display:none}}' +
    '@media (prefers-reduced-motion:reduce){.sc-clip{display:none}.sc-pend{animation:none}.sc-world.sc-glide{transition:none}}';
  document.head.appendChild(css);

  function el(tag, cls, parent) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (parent) parent.appendChild(e);
    return e;
  }

  var insts = [];

  /* the picture itself: still + clip / pendulum + glow + engraving canvas + vignette, inside a host box */
  function makeWorld(parent, kind) {
    var media = el('div', 'sc-media' + (kind === 'stage' ? ' sc-fill' : ''), parent);
    var world = el('div', 'sc-world' + (C.fx === 'candle' ? ' is-candle' : ''), media);
    var lit = el('div', 'sc-lit', world);
    var still = el('img', 'sc-still', lit);
    still.alt = kind === 'stage' ? '' : C.name + ' on a reclaimed table, with an engraved plaque';
    still.width = 1080; still.height = 1080;
    still.src = C.still;
    var clip = null;
    if (C.fx === 'candle' || C.fx === 'clip') {
      var cl = C.fx === 'candle' ? { url: C.flame, box: [0, 250, 290, 430] } : C.clip;
      clip = el('video', 'sc-clip' + (C.fx === 'candle' ? ' is-candle' : '') + (cl.edge ? ' is-edge' : ''), lit);
      clip.muted = true; clip.loop = true; clip.playsInline = true; clip.setAttribute('playsinline', ''); clip.setAttribute('muted', '');
      clip.preload = 'none';
      clip.style.left = cl.box[0] + 'px'; clip.style.top = cl.box[1] + 'px'; clip.style.width = cl.box[2] + 'px'; clip.style.height = cl.box[3] + 'px';
      clip.setAttribute('data-src', cl.url);
      clip.addEventListener('playing', function () { clip.classList.add('is-on'); });
    }
    if (C.fx === 'candle') el('div', 'sc-glow', lit);
    if (C.fx === 'pend') {
      var w = C.pend.win;
      var pw = el('div', 'sc-pwin', lit);
      pw.style.left = w[0] + 'px'; pw.style.top = w[1] + 'px'; pw.style.width = w[2] + 'px'; pw.style.height = w[3] + 'px';
      var sh = el('img', 'sc-pend sc-sh', pw); sh.alt = ''; sh.src = C.pend.shadow;
      var pe = el('img', 'sc-pend', pw); pe.alt = ''; pe.src = C.pend.url;
    }
    var eng = el('canvas', 'sc-eng is-sample', world);
    eng.style.width = FW + 'px'; eng.style.height = FH + 'px';
    eng.style.transform = MATRIX;
    el('div', 'sc-vig', media);
    return { kind: kind, host: media, world: world, eng: eng, clip: clip, zoomed: false, s: 0 };
  }

  /* gallery: our slide goes first, with a thumbnail first (desktop) */
  function build(gallery) {
    var slidesEl = gallery.querySelector('slideshow-slides');
    var first = slidesEl && slidesEl.querySelector('slideshow-slide');
    if (!slidesEl || !first) return null;

    var slide = document.createElement('slideshow-slide');
    slide.setAttribute('ref', 'slides[]');
    slide.setAttribute('data-scene-slide', '1');
    slide.setAttribute('aria-hidden', 'false');
    first.setAttribute('aria-hidden', 'true');
    slide.setAttribute('style', '--slideshow-timeline: --slide-scene; --product-media-fit: contain; --grid-template-rows: 50dvh 1fr; --grid-template-rows-desktop: 70dvh 1fr;');
    slide.className = 'product-media-container constrain-height media-fit-contain product-media-container--image';
    var pm = el('div', 'product-media', slide);
    pm.style.setProperty('--ratio', '1.0');
    var I = makeWorld(pm, 'gallery');
    I.gallery = gallery; I.slide = slide;

    /* the browser keeps the slide it had snapped to (the old first one) after an insert: pin the scroller to our slide */
    var snapPrev = slidesEl.style.scrollSnapType;
    slidesEl.style.scrollSnapType = 'none';
    slidesEl.insertBefore(slide, first);
    slidesEl.scrollLeft = 0;
    var settle = function () { slidesEl.scrollLeft = 0; };
    requestAnimationFrame(function () { settle(); requestAnimationFrame(function () { settle(); slidesEl.style.scrollSnapType = snapPrev; }); });

    /* thumbnail (desktop) goes first and the others shift by one */
    var tw = gallery.querySelector('.slideshow-controls__thumbnails');
    if (tw) {
      var tb = tw.querySelectorAll('button.slideshow-controls__thumbnail');
      var proto = tb[0];
      if (proto) {
        var nt = proto.cloneNode(true);
        nt.setAttribute('on:click', '/select/0');
        nt.setAttribute('aria-label', 'Animated scene, slide 1');
        nt.setAttribute('aria-selected', 'true');
        var badge = nt.querySelector('.slideshow-controls__thumbnail-badge');
        if (badge) badge.remove();
        var ti = nt.querySelector('img');
        if (ti) {
          ti.removeAttribute('srcset'); ti.removeAttribute('sizes');
          ti.src = C.still + (C.still.indexOf('?') > -1 ? '&' : '?') + 'width=144';
          ti.alt = '';
        }
        tb.forEach(function (b, i) {
          b.setAttribute('on:click', '/select/' + (i + 1));
          b.setAttribute('aria-label', 'Slide ' + (i + 2) + ' of ' + (tb.length + 1));
          b.setAttribute('aria-selected', 'false');
        });
        tw.insertBefore(nt, proto);
      }
    }
    var ss = gallery.querySelector('slideshow-component');
    if (ss && typeof ss.updatedCallback === 'function') { try { ss.updatedCallback(); } catch (e) { /* refs are rebuilt by the theme's own observer */ } }
    I.ss = ss;
    return I;
  }

  /* phone: the animated picture lives INSIDE the old urn-picture's scene box, so every motion of the existing phone UI
     (tap to see the whole urn, +/- and pinch, "Zoom in / Zoom out", the glide while typing) moves our picture too */
  function buildStage(stage) {
    var scene = stage.querySelector('.urn-live__scene');
    if (!scene) return null;
    stage.setAttribute('data-sc-host', '1');
    var I = makeWorld(scene, 'stage');
    I.scene = scene;
    I.urn = stage.closest('.urn-live');
    var later = 0;
    function follow() {
      place(I, true); draw(I);
      clearTimeout(later);
      later = setTimeout(function () { place(I, true); draw(I); }, 2200); /* after the glide ends: sharp text at the new size */
    }
    if (I.urn && typeof MutationObserver === 'function') {
      new MutationObserver(follow).observe(I.urn, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    }
    return I;
  }

  /* ---- the engraving on the flat plaque ---- */
  function inputEl() { return document.querySelector('[data-plaque-input]'); }
  function visibleInput() { var i = inputEl(); return i && i.offsetParent !== null ? i : null; }
  function lines(v) {
    return String(v || '').split('\n').map(function (s) { return s.replace(/\s+/g, ' ').trim(); }).filter(Boolean).slice(0, 3).map(function (s) { return s.slice(0, 30); });
  }
  function effScale(I) {
    var k = I.host.clientWidth / 1080;
    return (I.s || k) * (PW / FW);
  }
  function draw(I) {
    if (!I || !I.eng.isConnected) return;
    var inp = inputEl();
    var typed = inp ? lines(inp.value) : [];
    var L = typed.length ? typed : lines(SAMPLE);
    I.eng.classList.toggle('is-sample', !typed.length);
    var uh = document.querySelector('[data-urn-live]');
    I.eng.classList.toggle('is-off', !!(uh && uh.hidden));
    var eff = effScale(I) || 0.15;
    var P = Math.max(0.2, Math.min(2, eff * (window.devicePixelRatio || 1) * 1.6));
    var cw = Math.round(FW * P);
    var cv = I.eng;
    if (cv.width !== cw) { cv.width = cw; cv.height = Math.round(FH * P); }
    var ctx = cv.getContext('2d'), W = cv.width, Hh = cv.height;
    ctx.clearRect(0, 0, W, Hh);
    var d = W / 24, rr = 0.16 * Hh, R = rr + d, a = Math.sqrt(R * R - d * d), th = Math.asin(d / R);
    ctx.save();
    var dark = C.fx === 'candle';
    ctx.strokeStyle = dark ? 'rgba(34,17,6,.9)' : 'rgba(66,38,20,.72)'; ctx.lineWidth = W * (dark ? 0.0078 : 0.0067); ctx.lineJoin = 'round';
    ctx.beginPath();
    ctx.moveTo(a, d); ctx.lineTo(W - a, d); ctx.arc(W, 0, R, Math.PI - th, Math.PI / 2 + th, true);
    ctx.lineTo(W - d, Hh - a); ctx.arc(W, Hh, R, 1.5 * Math.PI - th, Math.PI + th, true);
    ctx.lineTo(a, Hh - d); ctx.arc(0, Hh, R, -th, -Math.PI / 2 + th, true);
    ctx.lineTo(d, a); ctx.arc(0, 0, R, Math.PI / 2 - th, th, true);
    ctx.closePath(); ctx.stroke(); ctx.restore();
    var innerW = W - 2 * d, innerH = Hh - 2 * d;
    var base = L.length === 1 ? [0.24] : L.length === 2 ? [0.215, 0.15] : [0.215, 0.15, 0.14];
    var sizes = base.map(function (f) { return f * innerH; }), hts = [];
    ctx.textBaseline = 'alphabetic'; ctx.fillStyle = dark ? 'rgba(28,13,4,.98)' : 'rgba(66,38,20,.92)';
    L.forEach(function (t, i) {
      ctx.font = '600 ' + sizes[i] + 'px ' + FONT;
      while (ctx.measureText(t).width > innerW * 0.86 && sizes[i] > 6) { sizes[i] *= 0.96; ctx.font = '600 ' + sizes[i] + 'px ' + FONT; }
      var m = ctx.measureText(t);
      hts.push({ asc: m.actualBoundingBoxAscent, desc: m.actualBoundingBoxDescent });
    });
    var gap = innerH * 0.075, tot = 0;
    hts.forEach(function (q) { tot += q.asc + q.desc; });
    tot += gap * (L.length - 1);
    var y = Hh / 2 - tot / 2;
    L.forEach(function (t, i) {
      ctx.font = '600 ' + sizes[i] + 'px ' + FONT;
      var w = ctx.measureText(t).width;
      ctx.fillText(t, W / 2 - w / 2, y + hts[i].asc);
      y += hts[i].asc + hts[i].desc + gap;
    });
  }
  var raf = 0;
  function redraw() { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { insts.forEach(draw); }); }

  /* ---- scale to the host, zoom glide ---- */
  /* the gallery slot can be taller than wide (laptop windows): keep the picture a true square that fits the slot */
  function squareFit(I) {
    if (I.kind !== 'gallery') return;
    var m = I.host, pm = m.parentElement;
    if (!pm) return;
    m.style.width = ''; m.style.height = '';
    var w = pm.clientWidth, h = pm.clientHeight;
    if (!w || !h) return;
    var s = Math.floor(Math.min(w, h));
    m.style.width = s + 'px'; m.style.height = s + 'px';
  }
  function place(I, instant) {
    if (I.kind === 'stage') {
      var sw = I.scene.offsetWidth;
      if (!sw) return;
      var kk = sw / 1080;
      I.world.style.transform = 'scale(' + kk + ')';
      var rw = I.scene.getBoundingClientRect().width;
      I.s = kk * (rw && sw ? rw / sw : 1);
      return;
    }
    squareFit(I);
    if (Date.now() < (I.glideUntil || 0)) instant = false; /* a re-layout during the glide must not cancel the ease */
    var tw = I.host.clientWidth, th = I.host.clientHeight;
    if (!tw || !th) return;
    var k = tw / 1080, s, tx = 0, ty = 0;
    var overlay = I.kind === 'stage' && I.urn && I.urn.classList.contains('is-zoomed');
    if (overlay) {
      /* the full-screen "whole urn" view of the phone picture: the whole scene */
      s = Math.min(k, th / 1080) || k;
      tx = (tw - 1080 * s) / 2; ty = (th - 1080 * s) / 2;
    } else if (I.zoomed) {
      s = k * ZOOM;
      tx = tw / 2 - CX * s; ty = th / 2 - CY * s;
      tx = Math.min(0, Math.max(tw - 1080 * s, tx)); ty = Math.min(0, Math.max(th - 1080 * s, ty));
    } else if (I.kind === 'stage') {
      s = k;
      tx = (tw - 1080 * s) / 2; ty = th / 2 - (CY + 60) * s;
      tx = Math.min(0, Math.max(tw - 1080 * s, tx)); ty = Math.min(0, Math.max(th - 1080 * s, ty));
    } else {
      s = k;
    }
    I.s = s;
    I.world.classList.toggle('sc-glide', !instant);
    I.world.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
  }
  function zoomIn(I) {
    if (!I) return;
    I.zoomed = true; I.glideUntil = Date.now() + 2300; place(I, false);
    setTimeout(function () { draw(I); }, 900);
  }
  function zoomOut(I) {
    if (!I || !I.zoomed) return;
    I.zoomed = false; I.glideUntil = Date.now() + 2300; place(I, false); draw(I);
  }
  function showScene(I) {
    if (I && I.ss && typeof I.ss.select === 'function') { try { I.ss.select(0, undefined, { animate: true }); } catch (e) { /* ignore */ } }
  }
  function gal() { for (var i = 0; i < insts.length; i++) if (insts[i].kind === 'gallery') return insts[i]; return null; }

  /* ---- video + flicker only while a picture is on screen ---- */
  var slow = 0, slowT = 0, fast = 0, fastT = 0, gust = 0, tS = 0, tF = 0, last = 0, running = false, visCount = 0;
  function rnd() { return Math.random() * 2 - 1; }
  function step(now) {
    if (!running) return;
    var dt = Math.min(0.05, (now - last) / 1000); last = now;
    tS -= dt; if (tS <= 0) { slowT = rnd() * 0.55; tS = 0.25 + Math.random() * 0.7; }
    tF -= dt; if (tF <= 0) { fastT = rnd() * 0.9; tF = 0.03 + Math.random() * 0.09; }
    slow += (slowT - slow) * Math.min(1, dt * 3); fast += (fastT - fast) * Math.min(1, dt * 22);
    if (Math.random() < dt * 0.7) gust = (Math.random() < 0.7 ? -1 : 1) * (0.8 + Math.random() * 0.9);
    gust *= Math.exp(-dt * 7);
    var b = Math.max(-1.6, Math.min(1.6, slow * 0.8 + fast * 0.7 + gust)).toFixed(3);
    insts.forEach(function (I) { I.host.style.setProperty('--b', b); });
    requestAnimationFrame(step);
  }
  function watch(I) {
    if (typeof IntersectionObserver !== 'function') return;
    var was = false;
    new IntersectionObserver(function (es) {
      var on = es[0].isIntersecting;
      if (on === was) return;
      was = on;
      if (I.clip && !reduce) {
        if (on) {
          if (!I.clip.getAttribute('src')) I.clip.src = I.clip.getAttribute('data-src');
          var pr = I.clip.play(); if (pr && pr.catch) pr.catch(function () {});
        } else { I.clip.pause(); }
      }
      if (C.fx === 'candle' && !reduce) {
        visCount += on ? 1 : -1;
        if (visCount > 0 && !running) { running = true; last = performance.now(); requestAnimationFrame(step); }
        if (visCount <= 0) { running = false; visCount = 0; }
      }
    }, { threshold: 0.2 }).observe(I.host);
    if (typeof ResizeObserver === 'function') { var ro = new ResizeObserver(function () { place(I, true); draw(I); }); ro.observe(I.host); if (I.kind === 'gallery' && I.host.parentElement) ro.observe(I.host.parentElement); }
  }
  function register(I) { insts.push(I); place(I, true); draw(I); watch(I); return I; }

  function findGallery() {
    return document.querySelector('[data-testid="product-information-media"] media-gallery') || document.querySelector('media-gallery');
  }
  function setupGallery() {
    var g = findGallery();
    if (!g || g.querySelector('[data-scene-slide]') || !g.querySelector('slideshow-slides slideshow-slide')) return;
    var old = gal();
    if (old) insts.splice(insts.indexOf(old), 1);
    var I = build(g);
    if (I) register(I);
  }
  function setupStage() {
    var st = document.querySelector('.urn-live__stage');
    if (!st || st.hasAttribute('data-sc-host')) return;
    var SI = buildStage(st);
    if (SI) register(SI);
  }
  function tryNow() { setupGallery(); setupStage(); }

  /* ---- typing hooks (the plaque box belongs to plaque-live.js; we only listen) ---- */
  document.addEventListener('focusin', function (e) {
    if (!insts.length || !e.target.matches || !e.target.matches('[data-plaque-input]')) return;
    redraw();
    if (desktop.matches) { var g = gal(); showScene(g); zoomIn(g); }
  }, true);
  document.addEventListener('focusout', function (e) {
    if (!insts.length || !e.target.matches || !e.target.matches('[data-plaque-input]')) return;
    setTimeout(function () { if (!document.activeElement || !document.activeElement.matches('[data-plaque-input]')) insts.forEach(zoomOut); }, 350);
  }, true);
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-plaque-input]')) redraw();
  }, true);
  document.addEventListener('click', function (e) {
    if (!insts.length || !e.target.closest) return;
    if (e.target.closest('[data-plaque-save]')) { insts.forEach(zoomOut); }
    if (e.target.closest('[data-plaque-change], .plaque-live__change')) { redraw(); }
  }, true);
  document.addEventListener('change', function () { setTimeout(redraw, 80); }, true);

  /* ---- build the slide as soon as the gallery is parsed (before the theme's components wake up), and again if the theme swaps the gallery (variant change) ---- */
  tryNow();
  document.addEventListener('DOMContentLoaded', tryNow);
  if (typeof MutationObserver === 'function') {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; tryNow(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.fonts && document.fonts.load) {
    var ready = function () { redraw(); };
    document.fonts.load('600 40px "Playfair Display"').then(ready, ready);
  }
  window.addEventListener('resize', function () { insts.forEach(function (I) { place(I, true); }); redraw(); });
})();
